module.exports = __webpack_public_path__ + "media/images/icon-end-of-sale-information-97c8d839f85f59382661045170c6fd0d.svg";